import React from 'react'

import { Box, Icon, IconButton } from '@mui/material'

import {
  AgentInfoSection,
  IncomingCallSection,
  CallSection,
  MiddleSection,
  ContactSection
} from './Section'

const IvrBar = (props) => {
  const {
    canDisplayIconConnectButton,
    canDisplayIvrComponents,
    agentStatus,
    isMute,
    onMute,
    hasActiveFirstConnection,
    hasThirdPartyConnection,
    isAutoAccept,
    onClick
  } = props

  return (
    <Box display='flex' alignItems='center' gap={1}>
      {!!canDisplayIvrComponents &&
        <Box display='flex' alignItems='center'>
          <AgentInfoSection />
          {agentStatus?.name === 'Busy' &&
            <IconButton aria-label="ivr" style={{ color: isMute ? 'red' : 'white' }} onClick={onMute} >
              <Icon >{isMute ? 'mic_off' : 'mic'}</Icon>
            </IconButton>
          }
          {!isAutoAccept && agentStatus?.name === 'PendingBusy' &&
            <IncomingCallSection />
          }
          {hasActiveFirstConnection &&
            <CallSection />
          }
          {hasActiveFirstConnection && hasThirdPartyConnection &&
            <MiddleSection />
          }
          {hasThirdPartyConnection &&
            <CallSection isThirdConnection />
          }
          <ContactSection />
        </Box>
      }
      {!!canDisplayIconConnectButton &&
        <IconButton aria-label="ivr" style={{ color: 'white' }} onClick={onClick} >
          <Icon >{'account_box'}</Icon>
        </IconButton>
      }
    </Box>
  );
}

export default React.memo(IvrBar)
